import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';

import { useReportPage } from 'shared/hooks';

import DoughnutChartSvg from './DoughnutChartSvg';

const useStyles = makeStyles({
  container: {
    position: 'relative',
    textAlign: 'center',
  },
  scoreBox: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, 60px)',
    '& span:nth-child(1)': {
      fontSize: '25px',
    },
  },
});

const DoughnutChart = ({ width, height, margin, data, colors, title, fontSize }) => {
  const ref = useRef(null);
  const [chart, setChart] = useState();
  const classes = useStyles();

  useEffect(() => {
    if (chart) {
      chart.destroy();
    }

    // eslint-disable-next-line no-new
    setChart(
      new DoughnutChartSvg({
        containerRef: ref.current,
        small: useReportPage,
        width,
        height,
        margin,
        data,
        colors,
        fontSize,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (chart) {
      chart.init();
    }
  }, [chart]);

  useEffect(() => {
    return () => {
      if (chart) {
        chart.destroy();
      }
    };
  });

  return (
    <div ref={ref} className={classes.container}>
      {title && (
        <Box mb={3}>
          <Typography align="center" variant="h5">
            <strong>{title}</strong>
          </Typography>
        </Box>
      )}
    </div>
  );
};

DoughnutChart.defaultProps = {
  width: 400,
  height: 250,
  margin: 0,
  colors: [],
  title: undefined,
  fontSize: 16,
};

DoughnutChart.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.node,
  colors: PropTypes.array,
  width: PropTypes.number,
  height: PropTypes.number,
  margin: PropTypes.number,
  fontSize: PropTypes.number,
};

export default DoughnutChart;
